var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFinalVerificationIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "noun-verification-4191653",
    d: "M105,3a3,3,0,0,1,3-3h22a3,3,0,0,1,3,3V14.339a13.334,13.334,0,0,1-1.03,6.135,17.549,17.549,0,0,1-4.28,5.056c-1.992,1.748-4.645,3.731-8.1,6.275a1,1,0,0,1-1.187,0c-3.453-2.544-6.106-4.528-8.1-6.275a17.549,17.549,0,0,1-4.28-5.056A13.336,13.336,0,0,1,105,14.339Zm19.669,7.743a1,1,0,1,0-1.338-1.487l-6,5.4-2.664-2.4a1,1,0,1,0-1.338,1.487l3.333,3a1,1,0,0,0,1.338,0Z",
    transform: "translate(-105)",
    fill: "#0d7dd0",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinalVerificationIcon);
export default __webpack_public_path__ + "static/media/finalVerificationIcon.5c3ba8fe15041b740ed5a14b33afc1fd.svg";
export { ForwardRef as ReactComponent };